// extracted by mini-css-extract-plugin
module.exports = {"title":"File_title__3Jk_O","uploadBox":"File_uploadBox__v-aqg","inputFile":"File_inputFile__2H6rb","delete":"File_delete__3Y47n"};